export default __webpack_public_path__ + "static/media/syracuse-logo-dark.1d28dc90.png";